<template>
  <div class="addMoreCampaign">
    <div class="addMoreCampaign__back-to-campaign">
      <router-link :to="{name: 'campaigneditorpage', params: { id: this.$route.params.id, openModal}}">
        <img src="/img/icons/ic-arrow-left.svg" alt="">
        Back to campaign
        </router-link>
    </div>
    <div class="addMoreCampaign__header">
      <div class="addMoreCampaign__header__left">
        <div class="addMoreCampaign__header__left__title">
          <h1 class="large-title">Add listing to {{ campaignName }}</h1>
        </div>
      </div>
      <!-- <div class="addMoreCampaign__header__right">
        <div class="addMoreCampaign__header__right__back">
          <button class="btn-large primary" @click="backToCampaign">Back to campaign</button>
        </div>
      </div> -->
    </div>
    <div class="addMoreCampaign__filter">
      <div class="addMoreCampaign__filter__left">
        <template v-if="selectedQuickValue == 'LS' || selectedTypeValue">
          <adx-dropdown-search @selected="selectedLocation" :list="locations"
          labelButton="Locations" :selected-value="selectedLocationValue"/>
          <adx-dropdown-checkbox v-if="brands.length > 0" @selected="selectedBrand"
            :list="brands"
            labelButton="Brands"
            :title="`Brands`" :default="selectedBrandValue" />
          <adx-dropdown-checkbox v-if="social.length > 0" @selected="selectedSocial"
            :list="social"
            labelButton="Social"
            :title="`Social`" :default="selectedSocialValue" />
          <adx-dropdown-checkbox v-if="profile.length > 0" @selected="selectedProfile"
            :list="profile"
            labelButton="Profile"
            :title="`Profile`" :default="selectedProfileValue" />
        </template>
        <template v-else-if="selectedQuickValue == 'ML'">
          <adx-dropdown-checkbox v-if="brands.length > 0" @selected="selectedBrand"
          :list="brands"
          labelButton="Brands"
          :title="`Brands`" :default="selectedBrandValue" />
        </template>
        <template v-else-if="selectedQuickValue == 'BU'">
          <adx-dropdown-checkbox v-if="surroundings.length > 0" @selected="selectedSurrounding"
          :list="surroundings"
          labelButton="Surrounding"
          :title="`Surrounding`" :default="selectedSurroundingValue" />
        </template>
        <template v-else-if="selectedQuickValue == 'AR'">
          <adx-dropdown-search labelButton="Locations" :list="locations" @selected="selectedLocation" :selected-value="selectedLocationValue"/>
          <adx-dropdown-checkbox v-if="brands.length > 0" labelButton="Brands" :list="brands" :title="`Brands`" :default="selectedBrandValue" @selected="selectedBrand"/>
        </template>
        
        <!-- <adx-dropdown-list class="addMoreCampaign__filter__left__sort--mobile" @selected="selectedType" :list="quickFilter" labelButton="Type" :title="`Type`" /> -->
        <adx-dropdown-list class="addMoreCampaign__filter__left__sort--mobile"
        @selected="selectedSort" :list="sort" labelButton="Sort by" :title="`Sort by`" />
        <div class="addMoreCampaign__filter__left__sort--mobile">
          <button class="btn-regular" :class="[labelType == 'Type' ? 'secondary' : 'teal']" @click="showQuickFilter = true">{{labelType}}</button>
        </div>
        <template v-if="selectedLocationValue || selectedBrandValue.length || selectedSocialValue.length || selectedProfileValue.length || selectedSurroundingValue.length">
          <div class="reset">
            <button class="btn-regular primary" @click.stop="clearFilter">Reset</button>
          </div>
        </template>
      </div>
      <div class="addMoreCampaign__filter__right">
        <p>Sort by :</p>  
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :label="`Select sort`" :options="sort" />
        </div>
      </div>
    </div>
    <div class="addMoreCampaign__content">
      <div class="addMoreCampaign__content__left">
        <div class="addMoreCampaign__content__left__header">
          <div class="addMoreCampaign__content__left__header__breadcrumb">
            <adx-breadcrumb :items="breadcrumb" />
          </div>
          <div class="addMoreCampaign__content__left__header__search">
            <div class="addMoreCampaign__content__left__header__search__input">
              <i class="adx-ic_search"></i>
              <input type="text" class="subhead" placeholder="Search" v-model="searchBoxValue">
            </div>
          </div>
        </div>
        <div v-if="searchError" class="addMoreCampaign__content__left__header__error">
          <div class="addMoreCampaign__content__left__header__error__top">
            <span>What worse, a hilarious no result page can't be found either : </span>
            <span class="search">"{{searchBoxValue}}"</span>
          </div>
          <div class="addMoreCampaign__content__left__header__error__bot">
            <span>Maybe you want to check other listing :</span>
          </div>
        </div>
        <div class="addMoreCampaign__content__left__listing">
          <adx-list-item @reloadData="initalLoad" :channel="selectedQuickName" :loading="isLoading" :items='items' :headers='headers' @loadMore="loadData">
            <!-- <infinite-loading slot="infiniteLoading" @infinite="loadData($event)" :isFirstLoad="false" :distance="1" ref="InfiniteLoadingRefs">
              <span slot="no-more">
              </span>
              <span slot="no-results">
              </span>
              <span slot="spinner">
              </span>
            </infinite-loading>
            <adx-loading v-if="isLoading" slot="loading" /> -->
            <template slot="infiniteLoading">
              <template v-if="!isLoading">
                <div v-if="next" class="addMoreCampaign__content__left__paging" @click.stop="loadData">
                  <span class="addMoreCampaign__content__left__paging__load">Show more</span>
                </div>
                <p class="nomore" v-else>There is no more data</p>
              </template>
              <template v-else>
                <adx-loading class="loading" v-if="isLoading" slot="loading" />
              </template>
            </template>
          </adx-list-item>
        </div>
      </div>
      <div class="addMoreCampaign__content__right">
        <adx-quick-filter :list="quickFilter" :value.sync="selectedQuickValue" @selectSub="selectSub" />
      </div>
    </div>
    <adx-modal v-if="showQuickFilter" title="Type" @modal-close="showQuickFilter = false">
      <div slot="content" class="content">
        <div class="addMoreCampaign__type">
          <ul>
            <li v-for="(item, index) in quickFilter" :key="index">
              <div class="addMoreCampaign__type__content" @click="selectType(item, index)">
                {{item.label.charAt(0).toUpperCase() + item.label.substr(1)}}
                <i v-if="item.subitem" :class="isTypeExpand.includes(index) ? 'icon-chevronup':'icon-chevrondown'"></i>
              </div>
              <div v-if="isTypeExpand.includes(index)" class="addMoreCampaign__type--child">
                <ul>
                  <li v-for="(child, chilin) in item.subitem" :key="chilin"
                  @click="selectSubType(child, item)">
                    {{child.label}}
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import ListAddMore from '@/views/CampaignEditor/AddMore/ListAddmore'
import Breadcrumb from '@/components/Breadcrumb'
import QuickFilter from '@/components/QuickFilter'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import Loading from '@/components/Loading/Primary'
import Modal from '@/components/Modal'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { fromKeys } from '@/lib/transformer'
import { deviceParams } from '@/api/params'
import types from '@/lib/types'
import InfiniteLoading from 'vue-infinite-loading'
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-addmore-campaigneditor',
  components: {
    'adx-list-item': ListAddMore,
    'adx-quick-filter': QuickFilter,
    'adx-dropdown-search': DropdownSearch,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-list': DropdownList,
    'infinite-loading': InfiniteLoading,
    'adx-dropdown-sort': DropdownSort,
    'adx-breadcrumb': Breadcrumb,
    'adx-loading': Loading,
    'adx-modal': Modal,
  },
  props: {

  },
  data() {
    return {
      items: [],
      count: 0,
      page: 1,
      next: null,
      isInit: true,
      isLoading: false,
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ],
      quickFilter: [],
      selectedQuickValue: ``,
      selectedQuickName: ``,
      search: [
        {
          'id': 0,
          'title': 'West Jakarta',
          'locations': [
            {
              'id': 0,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 1,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 2,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 3,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 4,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
            {
              'id': 5,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 6,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 7,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 8,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 9,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
          ]
        },
        {
          'id': 1,
          'title': 'West Jakarta',
          'locations': [
            {
              'id': 10,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 11,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 12,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 13,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 14,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
            {
              'id': 15,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 16,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 17,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 18,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 19,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
          ]
        },
        {
          'id': 2,
          'title': 'West Jakarta',
          'locations': [
            {
              'id': 20,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 21,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 22,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 23,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 24,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
            {
              'id': 25,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 26,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 27,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 28,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 29,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
          ]
        },
      ],
      checkbox: [
        {
          'id': 0,
          'label': 'Bebek Kaleyo',
          'value': 'BK',
        },
        {
          'id': 1,
          'label': 'Laus Kopi',
          'value': 'LK'
        },
        {
          'id': 2,
          'label': 'Upnormal',
          'value': 'UP'
        },
        {
          'id': 3,
          'label': 'Abuba',
          'value': 'AB'
        },
        {
          'id': 4,
          'label': 'Concordia',
          'value': 'CO'
        },
      ],
      sort: types.deviceOrdering,
      selectedSortValue: types.deviceOrdering[3].value,
      selectedSearchValue: '',
      searchBoxValue: '',
      searchError: false,
      locations: [],
      selectedLocationValue: '',
      brands: [],
      selectedBrandValue: [],
      social: [],
      selectedSocialValue: [],
      profile: [],
      selectedProfileValue: [],
      surroundings: [],
      selectedSurroundingValue: [],
      selectedTypeValue: '',
      selectedTypeName: '',
      selectedQuickName: 'All',
      showQuickFilter: false,
      labelType: 'All',
      isTypeExpand: [],
      openModal: true,
      campaignName: ''
    }
  },
  computed: {
    getFilterParams: function () {
      // if (this.isInit) this.initialRouteQuery(); this.isInit = false
      let params = {
        property_type: this.selectedTypeValue || undefined,
        sort_by: this.selectedSortValue || undefined,
        profile: this.selectedProfileValue.join(`,`) || undefined,
        brand: this.selectedBrandValue.join(`,`) || undefined,
        social: this.selectedSocialValue.join(`,`) || undefined,
        location: this.selectedLocationValue || undefined,
        search: this.searchBoxValue || undefined,
        category: this.selectedQuickValue || undefined,
        surrounding: this.selectedSurroundingValue.join(`,`) || undefined,
      }
      this.$router.replace({
        query: params
      })
      return params
    },
    breadcrumb () {
      const params = [
        {
          title: this.selectedQuickName
        },
        {
          title: this.selectedTypeName
        }
      ]

      return params
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(() => {
        this.initalLoad()
      });
    }, 500),
    selectedQuickValue: function(newValue, oldValue) {
      const QuickName = this.quickFilter.filter(data => {
        return data.value == newValue
      })
      
      this.selectedQuickName = QuickName.pop().label
      this.labelType = this.selectedQuickName.charAt(0).toUpperCase() + this.selectedQuickName.substr(1)
      this.selectedTypeValue = undefined
      this.selectedTypeName = undefined
      this.searchBoxValue = ''
      this.$nextTick(() => {
        this.initalLoad()
      });
    },
    selectedSortValue: function () {
      this.$nextTick(() => {
        this.initalLoad()
      });
    },
  },
  beforeCreate() {

  },
  created() {
    this.getCampaignName()
  },
  beforeMount() {
    // this.getFilter()
    this.getQuickFilter()
  },
  mounted() {
    // this.initialRouteQuery();
    // this.initalLoad();
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectType(item, index){
      if (item.subitem) {
        const include = this.isTypeExpand.includes(index)
        this.isTypeExpand = []
        if (!include) this.isTypeExpand.push(index)
      } else {
        this.showQuickFilter = false
      }
      this.selectedQuickValue = item.value
    },
    selectSubType(item, parent) {
      this.labelType = item.label.charAt(0).toUpperCase() + item.label.substr(1)
      this.showQuickFilter = false
      this.selectSub(item, parent)
    },
    selectedLocation(item){
      this.selectedLocationValue = item.id.toString()
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectSub(item, parent) {
      this.searchBoxValue = ''
      this.selectedTypeValue = item.value
      this.selectedTypeName = item.label
      this.selectedQuickValue = undefined
      this.selectedQuickName = parent.label
      this.initalLoad()
    },
    getFilter () {
      (async () => {
        const categoryName = this.selectedQuickValue
        const { data } = await api.get(apiV2.deviceFilters, {
          params: deviceParams[categoryName]
        })
        this.mapFilter(data)
      })();
    },
    getQuickFilter () {
      (async () => {
        const { data } = await api.get(apiV2.devicesFilters)
        const params = data.map( category => {
          if(category.child){
            const subitem = category.child.map(child => {
              return {
                label: child.name,
                value: child.value
              }
            })
            return {
              label: category.name,
              value: category.value,
              subitem: subitem
            }
          }
          return {
            label: category.name,
            value: category.value
          }
        })
        this.quickFilter = params
        this.quickFilter.sort((a, b) => { 
          let orderingRule = ['LS', 'BU', 'ML', 'AR']
          return orderingRule.indexOf(a.value) - orderingRule.indexOf(b.value)
         })

        const all = {
          label: 'All',
          value: ''
        }

        this.quickFilter.unshift(all)
        this.getFilter()
        this.initialRouteQuery()
      })();
    },
    mapFilter (data) {
      const brands = data.brands.map(brand => {
        return {
          id: brand.id,
          label: brand.title,
          value: brand.id
        }
      })
      const social = data.social.map(social => {
        return {
          id: social.id,
          label: social.title,
          value: social.level
        }
      })
      const profile = data.profile.map(social => {
        return {
          id: social.id,
          label: social.name,
          value: social.id
        }
      })
      this.brands = brands
      this.social = social
      this.profile = profile
      this.surroundings = fromKeys(data.surrounding)
      this.locations = data.cities
    },
    selectedBrand(item){
      this.selectedBrandValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedSocial(item){
      this.selectedSocialValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedType(item){
      this.selectedTypeValue = item.value
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedSort(item){
      if (this.selectedSortValue === item.value) {
        this.selectedSortValue = `name`
      } else {
        this.selectedSortValue = item.value
      }
    },
    selectedProfile(item){
      this.selectedProfileValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedSurrounding(item){
      this.selectedSurroundingValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    resetPageState () {
        this.$data.items = []
        this.$data.count = null
        this.$data.page = 1
        this.$data.next = null
    },
    initalLoad(isInit = null){
      (async () => {
        this.$data.isLoading = true
        this.searchError = false
        const categoryName = this.$options.name.split(`-`).pop()
        const campaignId = this.$route.params.id
        let params = {
          ...deviceParams[categoryName],
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.addMoreCampaign(campaignId), { needToken: true, params: params })
        if (!data.count && this.searchBoxValue) {
          this.searchError = true;
        }
        this.count = data.count
        this.items = data.results
        this.page = 2
        this.next = data.next
        
        // this.next = isInit
        // if (data.next) {
        //   this.next = data.next
        // }
        this.$data.isLoading = false
      })();
    },
    async loadData($state) {
      if (this.next) {
        this.isLoading = true
        let params = {
          page: this.page,
          ...this.getFilterParams
        }
        const campaignId = this.$route.params.id
        const { data } = await api.get(apiV2.addMoreCampaign(campaignId), { needToken: true, params: params })
        if (data.results) {
          // this.items = this.items.concat(data.results)
          // this.next = data.next
          // $state.loaded();
          // if (!data.next) {
          //   $state.complete()
          // }
          this.$data.items = this.$data.items.concat(data.results)
          // this.$data.count = data.count
          this.$data.next = data.next
        } else {
          // $state.complete()
        }
        this.page += 1
        this.isLoading = false
      }
    },
    backToCampaign() {
      this.$router.push({name: 'campaigneditorpage', params: { id: this.$route.params.id }})
    },
    initialRouteQuery() {
      Object.keys(this.$route.query).map(key => {
        if (this.$route.query[key]) {
          if (key == 'sort_by') this.selectedSortValue = this.$route.query[key]
          if (key == 'profile') this.selectedProfileValue = this.$route.query[key].split(',')
          if (key == 'brand') this.selectedBrandValue = this.$route.query[key].split(',')
          if (key == 'social') this.selectedSocialValue = this.$route.query[key].split(',')
          if (key == 'location') this.selectedLocationValue = this.$route.query[key]
          if (key == 'surrounding') this.selectedSurroundingValue = this.$route.query[key].split(',')
          if (key == 'category') this.selectedQuickValue = this.$route.query[key]

          if (key == 'property_type') {
            this.selectedTypeValue = this.$route.query[key]
            this.quickFilter.map(data => {
              if (data.subitem) {
                data.subitem.map(child => {
                  if (child.value == this.selectedTypeValue) {
                    this.labelType = child.label
                    this.selectedTypeName = child.label
                    this.selectedQuickValue = undefined
                    this.selectedQuickName = data.label
                  }
                })
              }
            })
          }
        }
      })
      this.initalLoad();
    },
    clearFilter() {
      this.selectedLocationValue = ''
      this.selectedBrandValue = []
      this.selectedSocialValue = []
      this.selectedProfileValue = []
      this.selectedSurroundingValue = []
      this.resetPageState()
      this.initalLoad()
    },
    getCampaignName() {
      let params = {};
      (async () => {
        const { data } = await api.get(`v2/campaign/${this.$route.params.id}/info/`, { needToken: true, params: params })
        this.campaignName = data.title
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>